import { Download, RefreshCw, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { usePwaInstall } from "./usePwaInstall";

export function PwaInstallBanner() {
  const { installPrompt, isInstalled, install, needRefresh, updateServiceWorker } = usePwaInstall();
  const [dismissed, setDismissed] = useState(false);

  if (isInstalled || dismissed) return null;

  if (needRefresh) {
    return (
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-card border border-primary/30 shadow-lg rounded-xl px-4 py-3 max-w-sm w-[calc(100%-2rem)]">
        <RefreshCw className="w-5 h-5 text-primary shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">Nova versão disponível</p>
          <p className="text-xs text-muted-foreground">Atualize para obter as últimas melhorias.</p>
        </div>
        <Button size="sm" onClick={() => updateServiceWorker(true)}>Atualizar</Button>
        <button onClick={() => setDismissed(true)} className="text-muted-foreground hover:text-foreground" aria-label="Fechar">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  if (!installPrompt) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-card border border-primary/30 shadow-lg rounded-xl px-4 py-3 max-w-sm w-[calc(100%-2rem)]">
      <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
        <Download className="w-5 h-5 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Instalar ProcessoFlow</p>
        <p className="text-xs text-muted-foreground">Acesso rápido direto do dispositivo.</p>
      </div>
      <div className="flex items-center gap-1.5 shrink-0">
        <Button size="sm" onClick={install}>Instalar</Button>
        <button onClick={() => setDismissed(true)} className="text-muted-foreground hover:text-foreground" aria-label="Fechar">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
